export default __webpack_public_path__ + "static/media/its_electric_logo_and_brand_name.6ad12b19.svg";